module.exports = __webpack_public_path__ + "assets/img/a0270eb5ae41ad609c7f565d8fac212b.svg";